/* istanbul ignore file */
import {
  StyledInsightContent,
  StyledInsightItem,
  StyledInsightTitle,
  StyledInsightValue
} from './InsightItem.style';
import { useContext, useMemo, useState } from 'react';
import ProjectProgressionContext from '../../state/context';
import { onClickInsight } from '../../state/actions';
import { boolPropsToClassNames } from 'common/utils/style.utils';
import { mapInsightToDescription } from '../insights.view';
import ReadCheckbox from './ReadCheckbox';
import usePmProvider from 'components/hooks/PM/usePmProvider';
import { INSIGHTS_CATEGORIES } from '../insights.keys';

const InsightItem = ({ insight, toggleCheck }) => {
  const pmProvider = usePmProvider();
  const [isHovered, setIsHovered] = useState(false);
  const {
    state: { selectedInsightKey },
    dispatch
  } = useContext(ProjectProgressionContext);

  const Description = useMemo(
    () => mapInsightToDescription({ insight, pmProvider }),
    [insight.key]
  );

  const isSelected = selectedInsightKey === insight.key;
  const { isChecked, value, category = '' } = insight;
  const insightCategory = INSIGHTS_CATEGORIES[category];
  const categoryInView = (insightCategory?.name || '').toUpperCase();

  return (
    <StyledInsightItem
      className={boolPropsToClassNames({ isSelected, isChecked })}
      onClick={() => dispatch(onClickInsight(insight.key))}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <main>
        <StyledInsightTitle>{categoryInView}</StyledInsightTitle>
        <StyledInsightContent>
          <StyledInsightValue>{value}</StyledInsightValue>
          {Description}
        </StyledInsightContent>
      </main>
      <aside>
        {(isHovered || isChecked) && (
          <ReadCheckbox isChecked={isChecked} toggleCheck={toggleCheck} />
        )}
      </aside>
    </StyledInsightItem>
  );
};

export default InsightItem;
